import React from "react";
import { AlertTriangle } from "lucide-react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("UI error boundary:", error, info);
  }
  reset = () => {
    this.setState({ hasError: false });
    window.location.href = "/";
  };
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-50 p-6 text-center dark:bg-slate-950" data-testid="error-boundary">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-red-100 text-red-600 dark:bg-red-950">
            <AlertTriangle className="h-6 w-6" />
          </div>
          <p className="max-w-sm text-sm text-slate-600 dark:text-slate-400">
            Es ist ein unerwarteter Fehler aufgetreten. / An unexpected error occurred.
          </p>
          <button onClick={this.reset} className="rounded-md bg-slate-900 px-4 py-2 text-sm font-medium text-white dark:bg-white dark:text-slate-900">
            OK
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
